// extracted by mini-css-extract-plugin
export var spinnerCellContent = "_51c7f2148be7be7e74b5f4b9a39e5be7-css";
export var spinnerCellContentText = "_973cd911929d8ab8a7a8893aed3451b2-css";